const AddMontage = {
  props: [
    'checkboxValue',
    'showInstallation'
  ],
  data () {
    return {
      isChecked: this.checkboxValue
    }
  },
  watch: {
    checkboxValue(newValue) {
      this.isChecked = newValue
    }
  },
  methods: {
    handleClick: function(event) {
      bus.$emit('updateMontage', event.target.checked)
    }
  },
}


export default AddMontage
